(function () {
  'use strict';
  if (window.__kkTabRecallInit) return;
  window.__kkTabRecallInit = true;

  var MARQUEE_TEXT = 'VUELVE A KONKO · ';
  var MARQUEE_SPEED_MS = 150;

  var originalTitle = document.title;
  var isSwapped = false;
  var marqueeOffset = 0;
  var marqueeIntervalId = null;

  function stopMarquee() {
    if (marqueeIntervalId !== null) {
      clearInterval(marqueeIntervalId);
      marqueeIntervalId = null;
    }
  }

  function tick() {
    document.title = MARQUEE_TEXT.slice(marqueeOffset) + MARQUEE_TEXT.slice(0, marqueeOffset);
    marqueeOffset = (marqueeOffset + 1) % MARQUEE_TEXT.length;
  }

  function startMarquee() {
    stopMarquee(); // limpia cualquier temporizador anterior antes de iniciar uno nuevo
    marqueeOffset = 0;
    tick();
    marqueeIntervalId = setInterval(tick, MARQUEE_SPEED_MS);
  }

  function handleHidden() {
    if (isSwapped) return;
    originalTitle = document.title;
    isSwapped = true;
    startMarquee();
  }

  function handleVisible() {
    if (!isSwapped) return;
    stopMarquee();
    document.title = originalTitle;
    isSwapped = false;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      handleHidden();
    } else {
      handleVisible();
    }
  });

  window.addEventListener('pageshow', function () {
    if (!document.hidden) handleVisible();
  });
})();
